/**
 * HTML 문자열 내 plain text URL을 <a> 태그로 변환한다.
 * - 이미 <a> 태그 안에 있는 URL은 변환하지 않는다 (중복 방지).
 * - URL 끝의 후행 구두점(. , ) ] ; : ! ?)은 링크에서 제외한다.
 * - target="_blank" + rel="noopener noreferrer" 필수 적용.
 * - https?:// 시작 URL만 처리 (javascript: 등 비허용).
 */
export function linkifyHtml(html) {
  if (!html) return html;
  if (typeof html !== 'string') return html; // 비문자열 입력 방어 (숫자/객체 등)
  return html.replace(
    /(<a\b[^>]*>[\s\S]*?<\/a>)|(<[^>]+>)|(https?:\/\/[^\s<>"']+)/gi,
    (match, anchor, tag, url) => {
      if (anchor) return anchor; // 이미 <a> 태그인 경우 그대로 반환
      if (tag) return tag;       // 다른 HTML 태그는 그대로 반환
      if (url) {
        // 후행 구두점 제거 (마침표, 쉼표, 닫는 괄호 등)
        const trailingPunct = url.match(/[.,;:!?)\]'"]+$/);
        const cleanUrl = trailingPunct ? url.slice(0, -trailingPunct[0].length) : url;
        const suffix = trailingPunct ? trailingPunct[0] : '';
        return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" style="color:#3b82f6;word-break:break-all;">${cleanUrl}</a>${suffix}`;
      }
      return match;
    }
  );
}
